import { defineStore } from 'pinia';
import Layer from "erayic-com-pack/component/NewMap/NewMapLayer/Layer";

export const LayerBasicStore = defineStore({
  id: 'LayerBasicStyle', // id必填
  state: () => {
    return {
      options: {
        /** 世界底图 */
        World: {
          /** 图层实例 */
          Layer: Object as unknown as Layer,
          /** 陆地颜色 */
          fillColor: '#ffffff',
          /** 中国边界线+中国省界线颜色 */
          lineColor: 'rgba(27, 53, 65, 1)',
          /** 陆地边缘颜色 */
          worldLineColor: 'rgba(25, 45, 78, 1)',
          /** 海洋的颜色 */
          waterColor: '#a1dcff',
        },
        /** 海南底图 */
        CountyOut: {
          /** 图层实例 */
          Layer: Object as unknown as Layer,
          /** 海南省面的颜色 */
          fillColor: undefined,
          /** 各市县界线颜色 */
          lineColor: 'rgba(27, 53, 65, 0.8)',
          /** 市县文字颜色 */
          color: 'rgba(0, 0, 0, 1)',
          /** 当前市县图层Id */
          TownLayerId: ""
        },
        /** 海湾图层 */
        TwonBay: {
          /** 图层实例 */
          Layer: Object as unknown as Layer,
        }
      }
    }
  }
})